import type { KitManifest } from '../../shared/discoverKits';

const manifest: KitManifest = {
    slug: 'plannings',
    context: 'size2mix',
    name: 'Plannings & scheduling',
    description:
        "Configuration et visualisation des plannings de production et de topologie d'un réseau Nemo : timeline interactive, actions de sélection, création de planning, légende, headers.",
    status: 'planned',
    owner: 'platform-team',
    tags: [
        'planning',
        'plannings',
        'scheduler',
        'timeline',
        'production-planning',
        'topology-planning',
    ],
    nemoSources: [
        {
            label: 'Conteneur principal',
            path: 'apps/frontend-next/src/ui/views/pages/network/planning/PlanningContainer.tsx',
            note: 'Composition de la page : Header + Timeline + Actions + Legend.',
        },
        {
            label: 'Création',
            path: 'apps/frontend-next/src/ui/views/pages/network/planning/CreatePlanningContainer.tsx',
            note: 'Flux de création/édition de planning.',
        },
        {
            label: 'Header',
            path: 'apps/frontend-next/src/ui/views/pages/network/planning/HeaderSection.tsx',
            note: 'Titre + métadonnées + actions globales.',
        },
        {
            label: 'Actions',
            path: 'apps/frontend-next/src/ui/views/pages/network/planning/PlanningActions.tsx',
            note: 'Boutons globaux (run, save, etc.).',
        },
        {
            label: 'Actions de sélection',
            path: 'apps/frontend-next/src/ui/views/pages/network/planning/SelectionActionsContainer.tsx',
            note: 'Barre contextuelle quand des items sont sélectionnés sur la timeline.',
        },
        {
            label: 'Légende',
            path: 'apps/frontend-next/src/ui/views/pages/network/planning/Legend.tsx',
            note: 'Légende des codes couleur de la timeline.',
        },
        {
            label: 'Timeline',
            path: 'apps/frontend-next/src/ui/views/pages/network/planning/timeline/',
            note: 'Composants de la timeline interactive (rangée par actif/topologie, blocs draggables, sélection).',
        },
        {
            label: 'Production planning',
            path: 'apps/frontend-next/src/ui/views/pages/network/planning/production/',
            note: 'Sous-arbre spécifique aux disponibilités de production (par actif).',
        },
        {
            label: 'Topology planning',
            path: 'apps/frontend-next/src/ui/views/pages/network/planning/topology/',
            note: 'Sous-arbre spécifique aux changements topologiques (vannes, configurations réseau).',
        },
        {
            label: 'Actions modales',
            path: 'apps/frontend-next/src/ui/views/pages/network/planning/actions/',
            note: 'Modales d\'action (création, édition, suppression de blocs).',
        },
        {
            label: 'Scheduler (page dédiée)',
            path: 'apps/frontend-next/src/ui/views/pages/network/Scheduler.tsx',
            note: 'Page Scheduler liée — à considérer dans le même domaine.',
        },
    ],
    sharedComponents: [
        '@shared/PrototypeStudioLayout',
        '@shared/DataTable (listes de plannings, vues tabulaires alternatives)',
        '@shared/SegmentedControl (switch production/topology, granularité)',
        '@shared/modal/CenterModal (création/édition d\'un bloc)',
        '@shared/modal/RightSideModal (panneau détails d\'une sélection)',
        '@shared/AccordionItem (filtres latéraux)',
        '@shared/tag/* (statuts d\'un bloc planifié)',
    ],
    views: [
        {
            id: 'planning-timeline',
            label: 'Timeline — Vue principale',
            description:
                'Timeline horizontale par actif/topologie avec blocs draggables, header de période, légende.',
        },
        {
            id: 'planning-selection-actions',
            label: 'Timeline — Actions de sélection',
            description:
                'Barre contextuelle qui apparaît quand un ou plusieurs blocs sont sélectionnés (déplacer, supprimer, dupliquer).',
        },
        {
            id: 'planning-create',
            label: 'Création / édition d\'un planning',
            description:
                'Formulaire de création (nom, type, période, actifs concernés) puis édition incrémentale via la timeline.',
        },
        {
            id: 'production-planning',
            label: 'Production planning',
            description:
                'Vue dédiée disponibilités de production : par actif, codes couleur dispo/maintenance/arrêt.',
        },
        {
            id: 'topology-planning',
            label: 'Topology planning',
            description:
                'Vue dédiée changements de topologie : ouverture/fermeture de vannes, configurations réseau.',
        },
        {
            id: 'planning-legend',
            label: 'Légende',
            description:
                'Légende des codes couleur affichés sur la timeline (statuts, types de bloc).',
        },
    ],
    notes: `
- Manifest initial : pas de screenshots ni de kit partagé. Ce domaine est
  fortement visuel (timeline) → un kit @shared/plannings/ est probable une
  fois 2 protos émergés (Timeline réutilisable + composants Block/Row/Header).
- Considérer Scheduler.tsx comme partie intégrante : même domaine fonctionnel.
- Pour un premier proto, partir d'un mock de blocs simple + DataTable comme
  fallback, en attendant d'extraire la timeline réelle.
`.trim(),
};

export default manifest;
